<template>
  <div>
    <LandingHeroSearch />
    <ShopList />
    <LandingBecomePartner />
    <LandingTeam />
    <LandingPartners />
    <LandingFooter />
  </div>
</template>
<script setup>
// Nuxt will auto-import components based on the directory structure.
// Prefixing components with their folder name (e.g., LandingHeroSearch) 
// is Nuxt's default behavior for nested components.
</script>